import { render, staticRenderFns } from "./EWLimitConfigForm.vue?vue&type=template&id=3669d8d4&"
import script from "./EWLimitConfigForm.vue?vue&type=script&lang=js&"
export * from "./EWLimitConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports